var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkLines2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 192,
  height: 401,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#5CC9E6",
  strokeDasharray: "12 8",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 2,
  d: "M191 1v329c0 38.66-31.34 70-70 70H1"
})));
export default SvgWorkLines2;